module.exports = __webpack_public_path__ + "img/3pr.36957772.png";